<div class="wrapper">
  <app-generic-drop-down label="Choose" (value)="changeIndex($event)" [options]="searchOptions" titleName="title"
    valueName="value" [title]="activeCol[0]?.title || searchOptions[0].title" class="drop-down-container"
    [shouldEmitEmittedValue]="true"></app-generic-drop-down>
  <div class="search-input-container">
    <div class="input-field">
      <img src="assets/18x18/search.svg" alt="" class="search-icon" />
      <input class="text-field" [(ngModel)]="searchStr" (input)="searchLoanee()" [placeholder]="searchPlaceholder" />
      <img class="icon" src="assets/20x20/close.svg" [ngClass]="{ hide: !searchStr, show: searchStr }" alt="Remove Icon"
        (click)="removeClick()" />
    </div>
    <ng-container *ngIf="suggestionList && suggestionList.length > 0">
      <div class="suggestion-list" id="suggestionList">
        <div class="suggestion" *ngFor="let suggestion of suggestionList" (click)="onSuggestionSelect(suggestion)">
          <div class="name-section">
            <span class="full-name" [innerHTML]="getHighlightedText(suggestion.name, searchStr)"></span>
            <p class="email" [innerHTML]="getHighlightedText(suggestion.email, searchStr)"></p>
          </div>
          <div class="employee-section">
            <p>{{ suggestion.employeeId }}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>